import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { menu } from "../../translate";
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import VoiceChatIcon from '@mui/icons-material/VoiceChat';
import PhoneIcon from '@mui/icons-material/Phone';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { hasEmployeeTelegram, hasEmployeeWhatsApp, isSipEmployee } from '../../helpers/employeePermissions';

const getPermissions = (employeeData) => {
    if (!employeeData?.permission?.permissions_json) return [];
    try { return JSON.parse(employeeData.permission.permissions_json); } catch { return []; }
};

export const WorkerMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('employees_read')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/employees'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <PersonIcon />
                            {menu.worker[lang]}
                        </p>

                        <p>{countData?.sip || 0}</p>
                    </p>

                </NavLink>

            </h2>
        </div>
    )
}

export const GroupMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('groups_read')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/groups'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <GroupIcon />
                            {menu.group[lang]}
                        </p>

                        <p>{countData?.groups|| 0}</p>
                    </p>

                </NavLink>

            </h2>
        </div>
    )
}
export const IvrMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('ivr_read')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/ivrs'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <VoiceChatIcon />
                            {menu.ivr[lang]}
                        </p>

                        <p>{countData?.ivr|| 0}</p>
                    </p>

                </NavLink>

            </h2>
        </div>
    )
}

export const DiDMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('did_read')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/main_number'
                >
                    <span />

                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <PhoneIcon />
                            {menu.did[lang]}
                        </p>
                        <p>{countData?.did|| 0}</p>
                    </p>
                </NavLink>
            </h2>
        </div>
    )
}


export const ProviderMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('crm_integrations_manage')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/sip_providers'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <DnsOutlinedIcon />
                            {menu.provide[lang]}
                        </p>
                        <p>{countData?.provider|| 0}</p>
                    </p>
                </NavLink>
            </h2>
        </div>
    )
}

export const AutoCallMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('crm_integrations_manage')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingAuto`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/auto_call_list'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <SmartToyOutlinedIcon />
                            {menu.autoCall[lang]}
                        </p>
                        <p>{countData?.onlyAuto|| 0}</p>
                    </p>
                </NavLink>
            </h2>
        </div>
    )
}

export const ConferenceCallMenuItem = ({ lang, countData }) => {
    const employeeData = useSelector(state => state.users.employeeData);
    const permissions = getPermissions(employeeData);
    if (employeeData?.buddy && !permissions.includes('crm_integrations_manage')) {
        return null;
    }
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id={`headingConferenceCall`}>
                <NavLink
                    className="accordion-button accordion-link"
                    to='/conference_call_list'
                >
                    <span />
                    <p className='d-flex align-items-center justify-content-between w-100'>
                        <p>
                            <VoiceChatIcon />
                            {menu.conferenceCall?.[lang] || 'Conference call'}
                        </p>
                        <p>{countData?.conference ?? 0}</p>
                    </p>
                </NavLink>
            </h2>
        </div>
    )
}

const showTelegram = (employeeData) => {
    if (hasEmployeeTelegram(employeeData)) return true;
    const inStorage = typeof localStorage !== 'undefined' && localStorage.getItem('telegram');
    if (inStorage && isSipEmployee(employeeData)) return false;
    return !!inStorage;
};

const showWhatsApp = (employeeData) => {
    if (hasEmployeeWhatsApp(employeeData)) return true;
    const inStorage = typeof localStorage !== 'undefined' && localStorage.getItem('whatsapp');
    if (inStorage && isSipEmployee(employeeData)) return false;
    return !!inStorage;
};

export const TelegramMenuItem = () => {
    const employeeData = useSelector(state => state.users.employeeData);
    if (!showTelegram(employeeData)) return null;
    const firstTelegram = employeeData?.telegrams?.[0];
    const to = firstTelegram?.id != null ? `/history_telegram/${firstTelegram.id}` : '/connect/telegram';
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingTelegram">
                <NavLink to={to} className="accordion-button accordion-link">
                    <TelegramIcon style={{ fontSize: 24, marginRight: 10 }} />
                    Telegram
                </NavLink>
            </h2>
        </div>
    );
};

export const WhatsAppMenuItem = () => {
    const employeeData = useSelector(state => state.users.employeeData);
    if (!showWhatsApp(employeeData)) return null;
    const to = hasEmployeeWhatsApp(employeeData) ? '/history_whatsapp' : '/connect/whatsapp';
    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingWhatsApp">
                <NavLink to={to} className="accordion-button accordion-link">
                    <WhatsAppIcon style={{ fontSize: 24, marginRight: 11 }} />
                    WhatsApp
                </NavLink>
            </h2>
        </div>
    );
};